import authService from './services/auth.service';
import agentService from './services/agent.service';
import { loadAgency } from './agency';
import storage from '../helpers/storage';

export const AGENT_LOGIN = 'agent/AGENT_LOGIN';
export const AGENT_UPDATE = 'agent/AGENT_UPDATE';
export const AGENT_LOGOUT = 'agent/AGENT_LOGOUT';
export const REGISTER = 'agent/REGISTER';
export const RESETPASSWORD = 'agent/RESETPASSWORD';
export const USER_LOCAL_KEY = 'agent.user';

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  AGENCY: 'AGENCY'
};

const initialState = {
  user: storage.getItem(USER_LOCAL_KEY) || null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AGENT_LOGIN: {
      const user = action.payload && action.payload.user;
      storage.setItem(USER_LOCAL_KEY, user);
      return {
        ...state,
        user
      };
    }
    case AGENT_UPDATE: {
      const user = action.payload && action.payload.user;
      return {
        ...state,
        user
      };
    }
    case AGENT_LOGOUT:
      storage.setItem(USER_LOCAL_KEY, null);
      storage.deleteAllCookies();
      return {
        ...state,
        user: null
      };
    default:
      return state
  }
}

export const logInUser = (credentials) => {
  return (dispatch, getState) => {
    return authService.loginUser(credentials)
      .then((data) => {
        const { user, id } = data;
        user.tokenId = id;

        dispatch({
          type: AGENT_LOGIN,
          payload: {
            user
          }
        });

        if (user.agencyId) {
          loadAgency(user.agencyId)(dispatch, getState);
        }

        return user;
      });
  };
};

export const forgotPasswordUser = (credentials) => {
  return (dispatch, getState) => {
    return authService.forgotPassword(credentials)
      .then((response) => {

        console.log("agent.js file response", response);
        const { user, id } = response;
        user.tokenId = id;

        dispatch({
          type: AGENT_LOGIN,
          payload: {
            user
          }
        });
        return user;
      });
  };
};

export const logOutUser = () => {
  return dispatch => {
    dispatch({
      type: AGENT_LOGOUT
    });
  };
};

export const agentUpdate = (data) => {
  return (dispatch, getState) => {
    const currentUser = getState().auth.user;
    const id = currentUser.id;

    data = Object.assign(currentUser, data);

    return agentService.updateAgent(id, data)
      .then((user) => {
        dispatch({
          type: AGENT_UPDATE,
          payload: {
            user
          }
        });
        return data;
      });
  };
}

export const agentUpdatePassword = (oldPassword, newPassword) => {
  return (dispatch, getState) => {
    const currentUser = getState().auth.user;

    if (!currentUser) {
      console.log('user not logged in');
      return;
    }

    return agentService.updateAgentPassword(oldPassword, newPassword)
      .then((data) => {
        return data;
      });
  };
}

export const register = (accountDetails) => {
  return (dispatch) => {
    return authService.register(accountDetails)
      .then((user) => {
        dispatch({
          type: REGISTER,
          payload: {
            user
          }
        });
        return user;
      });
  };
}

export const resetPassword = (userPassword) => {
  return (dispatch) => {
    return authService.resetPassword(userPassword)
      .then((user) => {
        dispatch({
          type: RESETPASSWORD,
          payload: {
            user
          }
        });
        return user;
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/agent.js